/**
 * 
 */
class WMUNumber extends EventTarget {

    /**
     * 
     */
    constructor( element, args = {} )
    {
        super();

        this.inputElement = element;
        this.minusElement = null;
        this.plusElement = null;
        this.wrapperElement = null;

        this.args = {
            init: true,
            minusElementText: "-",
            plusElementText: "+",
            min: null,
            max: null,
            step: null,
            value: null,
            defaultStep: 1,
            defaultValue: 0,
            ...args
        };
        
        this.min = this.args.min;
        this.max = this.args.max;
        this.step = this.args.step;
        this.value = this.args.value;
        this.isInit = false;

        if ( true === this.args.init )
        {
            this.init();
        }
    }

    /**
     * Initialize the number replacement
     * 
     * @returns void
     */
    init()
    {
        if ( this.inputElement && ( 'input' === this.inputElement.nodeName.toLowerCase() ) )
        {
            if ( null === this.min )
            {
                const min = this.inputElement.getAttribute( 'min' );

                if ( min !== "" && min !== null )
                {
                    this.min = ( -1 === min.indexOf( '.' ) ) ? parseInt( min ) : parseFloat( min );
                }
            }
            
            if ( null === this.max )
            {
                const max = this.inputElement.getAttribute( 'max' );

                if ( max !== "" && max !== null )
                {
                    this.max = ( -1 === max.indexOf( '.' ) ) ? parseInt( max ) : parseFloat( max );
                }
            }
            
            if ( null === this.step )
            {
                const step = this.inputElement.getAttribute( 'step' );

                if ( step !== "" && step !== null )
                {
                    this.step = ( -1 === step.indexOf( '.' ) ) ? parseInt( step ) : parseFloat( step );
                }
            }

            if ( null === this.step )
            {
                this.step = this.args.defaultStep;
            }

            if ( null === this.value )
            {
                const value = this.inputElement.getAttribute( 'value' );

                if ( value !== "" && value !== null )
                {
                    this.value = ( -1 === value.indexOf( '.' ) ) ? parseInt( value ) : parseFloat( value );
                }
                else
                {
                    this.value = this.args.defaultValue;
                }
            }

            this.render();
            this.initBehaviors();
            this.isInit = true;
        }
        else
        {
            console.log( "No input[type='number'] element or invalid one." );
        }
    }

    /**
     * 
     */
    render()
    {
        this.wrapperElement = document.createElement( 'div' );
        this.wrapperElement.classList.add( 'wmu-number-wrapper' );
        this.inputElement.after( this.wrapperElement );
        this.wrapperElement.appendChild( this.inputElement );

        this.minusElement = document.createElement( 'div' );
        this.minusElement.classList.add( 'wmu-number-control', 'wmu-number-minus' );
        this.minusElement.textContent = this.args.minusElementText;
        this.inputElement.before( this.minusElement );

        this.plusElement = document.createElement( 'div' );
        this.plusElement.classList.add( 'wmu-number-control', 'wmu-number-plus' );
        this.plusElement.textContent = this.args.plusElementText;
        this.inputElement.after( this.plusElement );
    }

    /**
     * 
     */
    getValue()
    {
        return this.value;
    }

    /**
     * 
     */
    setValue( value )
    {
        if ( null !== this.min )
        {
            value = Math.max( value, this.min );
        }

        if ( null !== this.max )
        {
            value = Math.min( value, this.max );
        }

        this.value = value;
        this.inputElement.setAttribute( 'value', this.value );
        this.inputElement.dispatchEvent( new CustomEvent( 'change' ) );
    }

    /**
     * 
     */
    decrease()
    {
        this.setValue( this.getValue() - this.step );
    }

    /**
     * 
     */
    increase()
    {
        this.setValue( this.getValue() + this.step );
    }

    /**
     * Initialize behaviors
     * 
     * @returns void
     */
    initBehaviors()
    {
        this.onMinus = this.onMinus.bind( this );
        this.onPlus = this.onPlus.bind( this );

        this.minusElement.addEventListener( 'click', this.onMinus );
        this.plusElement.addEventListener( 'click', this.onPlus );
    }

    /**
     * 
     */
    onMinus( event )
    {
        this.decrease();
    }

    /**
     * 
     */
    onPlus( event )
    {
        this.increase();
    }

}

export default WMUNumber;